import products from './index.js';



const UPDATE_LIST = (state, products) => {
  state.products = products;
  state.outDated = false;
};

const SET_LOADING = (state, loading) => {
  state.loading = loading;
};

const SET_PAGES = (state, pages)=>{
  state.pages = pages;
}

const SET_PAGE = (state, page)=>{
  state.page = page;
}

const SET_COUNT = (state, count)=>{
  state.count = count;
}

const SET_SEARCH_TERMS = (state, searchTerms)=>{
  state.searchTerms =searchTerms;
}

const INVALIDATE_LIST = (state) =>{
  state.outDated = true;
  state.statsOutdated = true;
}

const INVALIDATE_STATS = (state) =>{
  state.statsOutdated = true;
}

const SET_STATS_LOADING = (state, statsLoading)=>{
  state.statsLoading = statsLoading;
}

const UPDATE_STATS = (state, stats)=>{
  state.stats = stats
}

const SET_CHECKED_ITEM_TYPES = (state, val)=>{
  state.productFilters.checkedItemTypes=val;
}
const SET_CHECKED_ITEM_TAXABLE = (state, val)=>{
  state.productFilters.checkedItemTaxables=val;
}
const SET_CHECKED_ITEM_ACTIVES = (state, val)=>{
  state.productFilters.checkedItemActives=val;

}

const SET_LIST_TAGS = (state, listTags)=>{
  state.listTags = listTags;
}

const SET_EXTENDED_OBJECTS = (state, extendedObjects) => {
  state.extendedObjects = extendedObjects;
}

const SET_PRODUCT_PUBLISHED_IND = (state, ind) => {
  state.productFilters.producPublishedInd = ind;
}

const SET_CMS_PRODUCT_PUBLISHED_IND = (state, ind) => {
  state.productFilters.cmsProducPublishedInd = ind;
}

const RESET_FILTERS = (state)=>{
  state.productFilters.producPublishedInd = null;
  state.productFilters.checkedTags = [];
  state.productFilters.active = null;
}

const RESET_CMS_FILTERS = (state)=>{
  state.productFilters.cmsProducPublishedInd = null;
  state.productFilters.cmsCheckedTags = [];
  state.productFilters.cmsActive = null;
}

const SET_ACTIVE_FILTER = (state, active) => {
  state.productFilters.active = active;
}

const SET_CMS_ACTIVE_FILTER = (state, active) => {
  state.productFilters.cmsActive = active;
}

const SET_CHECKED_TAGS = (state, tags)=>{
  state.productFilters.checkedTags = tags;
}

const SET_CMS_CHECKED_TAGS = (state, tags)=>{
  state.productFilters.cmsCheckedTags = tags;
}

const SET_ORIGIN = (state, origin) => {
  state.origin = origin;
}


export default {
  UPDATE_LIST,
  SET_PAGES,
  SET_PAGE,
  SET_COUNT,
  SET_LOADING,
  SET_SEARCH_TERMS,
  INVALIDATE_LIST,
  INVALIDATE_STATS,
  SET_STATS_LOADING,
  UPDATE_STATS,
  SET_CHECKED_ITEM_TYPES,
  SET_CHECKED_ITEM_TAXABLE,
  SET_CHECKED_ITEM_ACTIVES,
  SET_LIST_TAGS,
  SET_EXTENDED_OBJECTS,
  SET_CMS_PRODUCT_PUBLISHED_IND,
  SET_PRODUCT_PUBLISHED_IND,
  RESET_FILTERS,
  SET_ACTIVE_FILTER,
  SET_CHECKED_TAGS,
  SET_CMS_ACTIVE_FILTER,
  SET_CMS_CHECKED_TAGS,
  SET_ORIGIN,
  RESET_CMS_FILTERS,
};
